const START_CLOCK = "Start clock",
  STOP_CLOCK = "Stop clock";

export { START_CLOCK, STOP_CLOCK };
